/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.14.0
 * @since 1.14.0
 */

import classNames from 'classnames';

import { ImgStatusError } from '../../../components/common/Block/Img';
import { SubscriberIdErrorStyled } from './styled/SubscriberIdErrorStyled';

interface ISubscriberIdEmpty {
    left?: boolean;
    title: string;
    withoutImage?: boolean;
}

const SubscriberIdEmpty = ({ left, title, withoutImage }: ISubscriberIdEmpty) => (
    <SubscriberIdErrorStyled className={classNames({
        'subscriber-id-error_left': left,
        'subscriber-id-error_center': !left,
    })}>
        {!withoutImage && <ImgStatusError/>}
        <div className="subscriber-id-error__title">
            {title}
        </div>
    </SubscriberIdErrorStyled>
);

export default SubscriberIdEmpty;
